import { useState } from 'react'
import { IconChartHistogram } from '@tabler/icons-react'
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts'
import { DashboardCardWrapper } from '../../commonComponents/DashboardCardWrapper';

export const TopLeadCampaigns = () => {
    const analyticsData = [
        { month: "Summer Sale", sales: 31250 },
        { month: "Brand Awareness", sales: 18320 },
        { month: "Product Launch", sales: 45230 },
        { month: "Holiday Promo", sales: 24780 },
        { month: "Flash Deal", sales: 38900 }
    ];
    return (
        <DashboardCardWrapper
            headerText={"Top Campaigns"}
            headerSubtext={"Analyze category-wise growth and conversion trends over time."}
            headerIcon={<IconChartHistogram size={16} stroke={2} color={"#7a3a5e"} />}
            isDropdown={false}
        >
            <div
                className="d-flex w-100"
                style={{ flex: 1, height: '100%' }}
            >
                <ResponsiveContainer width="100%" height={220}>
                    <BarChart
                        barSize={70}
                        barGap={70}
                        data={analyticsData}
                    >
                        <defs>
                            <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#6d3fd1" stopOpacity={1} />
                                <stop offset="55%" stopColor="#8253e4" stopOpacity={1} />
                                <stop offset="100%" stopColor="#a57cff" stopOpacity={1} />
                            </linearGradient>

                            <linearGradient id="barGradientHover" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#5b2bc4" stopOpacity={1} />
                                <stop offset="55%" stopColor="#7446d8" stopOpacity={1} />
                                <stop offset="100%" stopColor="#9670f5" stopOpacity={1} />
                            </linearGradient>
                            <linearGradient id="bgBarGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#e5e7eb" stopOpacity={1} />
                                <stop offset="100%" stopColor="#f3f4f6" stopOpacity={1} />
                            </linearGradient>
                        </defs>
                        <XAxis
                            axisLine={false}
                            dataKey="month"
                            tickLine={false}
                            fontSize={12}
                            tickMargin={14}
                        />

                        <Tooltip
                            cursor={{ fill: 'transparent' }}
                            content={<CustomTooltip brandColor={"#7a3a5e"} />}
                        />

                        <Bar
                            bsckground
                            fill="url(#barGradient)"
                            activeBar={{
                                fill: 'url(#barGradientHover)',
                                radius: [8, 8, 0, 0],
                            }}
                            dataKey="sales"
                            radius={[8, 8, 8, 8]}
                            barSize={70}
                        />

                    </BarChart>
                </ResponsiveContainer>
            </div>
        </DashboardCardWrapper>
    )
}

const CustomTooltip = ({ active, payload, label, brandColor }) => {
    if (active && payload && payload.length) {
        return (
            <div
                className="bg-white rounded-3 p-3 shadow-lg border"
                style={{
                    borderColor: "#e2e8f0",
                    fontSize: "13px",
                    minWidth: "210px",
                    fontFamily: "inherit"
                }}
            >
                <div className="border-bottom pb-2 mb-2">
                    <span className="text-muted small d-block">Reporting Node</span>
                    <strong className="text-dark fw-bold">{label}</strong>
                </div>

                <div className="d-flex flex-column gap-2">
                    {payload
                        .filter((entry) => entry.dataKey !== "background")
                        .map((entry, index) => (
                            <div key={index} className="d-flex align-items-center justify-content-between gap-3">
                                <div className="d-flex align-items-center gap-2 text-secondary">
                                    <span
                                        className="rounded-circle d-inline-block"
                                        style={{
                                            width: "7px",
                                            height: "7px",
                                            backgroundColor: entry.stroke || entry.color
                                        }}
                                    />
                                    <span style={{ fontSize: "12px", fontWeight: "500" }}>{entry.name}:</span>
                                </div>
                                <span className="fw-bold text-dark text-end">
                                    {entry.dataKey === "sales" ? "" : "₹"}
                                    {Number(entry.value).toLocaleString('en-IN')}
                                </span>.
                            </div>
                        ))}
                </div>
            </div>
        )
    }
    return null
}
